// extracted by mini-css-extract-plugin
export var completionBody = "_el-2";
export var completionCard = "_el-0";
export var completionFooter = "_el-3";
export var completionTitle = "_el-1";